(function () {
  'use strict';
  var brandPattern = '\\b(?:Pentair\\s*[/ ]\\s*(?:Rainbow|American)|Hot\\s*Spring\\s*/\\s*Watkins|Coleman\\s*/\\s*Maax(?:\\s+Spas)?|Sundance(?:\\s+Spas)?|Artesian(?:\\s+Spas)?|Sunrise(?:\\s+Spas)?|Coleman(?:\\s+Spas)?|Maax(?:\\s+Spas)?|Sta[-\\s]?Rite|Leisure\\s+Bay|Rec\\s+Warehouse|Thermo\\s+Spa|Hayward|Pentair|Rainbow|Jandy|Waterway|Waterco|Jacuzzi|Coleco|Advantage|Softub|Elite|Icon|Magnum)\\b';
  function cleanSegment(value) {
    return value.replace(/^[\s,/&]+|[\s,/&]+$/g, '').replace(/^and\s+|\s+and$/gi, '').trim();
  }
  function brandName(value) {
    if (/rainbow/i.test(value)) return 'Rainbow';
    if (/pentair|american/i.test(value)) return 'Pentair';
    if (/coleman|maax/i.test(value)) return 'Coleman / Maax';
    if (/hot\s*spring|watkins/i.test(value)) return 'Hot Spring / Watkins';
    if (/sta[-\s]?rite/i.test(value)) return 'Sta-Rite';
    if (/sundance/i.test(value)) return 'Sundance Spas';
    if (/artesian/i.test(value)) return 'Artesian Spas';
    if (/sunrise/i.test(value)) return 'Sunrise Spas';
    return value;
  }
  function separateModels(value) {
    var parts = [];
    var start = 0;
    var separator = /\s*(?:,|&|\band\b|\/)\s*/gi;
    var match;
    while ((match = separator.exec(value))) {
      var current = value.slice(start, match.index).trim();
      var rest = value.slice(separator.lastIndex);
      var before = value.slice(0, match.index);
      // Split after a model, never inside a name such as Clean & Clear or a qualifier.
      if (!/\d/.test(current) || !rest || (before.match(/\(/g) || []).length > (before.match(/\)/g) || []).length) continue;
      // A cartridge reference or a capacity range is not another housing.
      if (/^CX[A-Z0-9-]*RE\b/i.test(rest) || /^\d+(?:\.\d+)?\s*(?:Sq\.?\s*Ft\.?|sqft|ft[²2])\b/i.test(rest)) continue;
      parts.push(current);
      start = separator.lastIndex;
    }
    parts.push(value.slice(start).trim());
    var family = '';
    var letteredModel = false;
    return parts.map(function (part) {
      // Carry the written family onto abbreviated models: SwimClear C4020, C4025.
      if (family && (/^\d+[A-Z0-9-]*$/i.test(part) || (letteredModel && /^[A-Z]+\d[A-Z0-9-]*$/i.test(part)))) {
        return family + ' ' + part;
      }
      var named = /^(.*\S)\s+([A-Z]*\d[A-Z0-9-]*)$/i.exec(part);
      family = named ? named[1] : '';
      letteredModel = !!(named && /^[A-Z]/i.test(named[2]));
      return part;
    });
  }
  function titleChoices(title) {
    var text = title.replace(/[®™]/g, '').replace(/\s+/g, ' ').trim();
    var forMatch = /\b(?:Replacement Filter Cartridges?|Retrofit Kit)\s*,?\s*(?:for|Compatible with)\s+/i.exec(text);
    if (forMatch) text = text.slice(forMatch.index + forMatch[0].length).split(/\s+[—–]\s+/)[0];
    else text = text.split(/\s+Replacement Filter Cartridges?\b/i)[0];
    var matcher = new RegExp(brandPattern, 'gi');
    var markers = Array.from(text.matchAll(matcher));
    var segments = markers.map(function (marker, index) {
      return {brand: brandName(marker[0]), text: cleanSegment(text.slice(marker.index + marker[0].length, index + 1 < markers.length ? markers[index + 1].index : text.length))};
    });
    var choices = [];
    segments.forEach(function (segment) {
      var model = segment.text;
      if (!model || !/\d/.test(model)) return;
      var note = '';
      if (/Retrofit Kits?\b/i.test(model)) note = 'Replacement cartridges for an installed retrofit kit. Confirm the assembly on the product page.';
      if (/\bRetrofit Kit for\b/i.test(title)) note = 'Complete retrofit kit. Check the product page for current availability.';
      var pair = segment.brand === 'Waterco' && /^Opal\s+XL\s+(.+?)\s*\/\s*XL\s*(\d+)\s+(Upper|Lower)\s+Element$/i.exec(model);
      if (pair) {
        choices.push({brand: segment.brand, family: 'Opal XL', model: pair[1], note: '', combination: '', position: ''});
        choices.push({brand: segment.brand, family: 'Opal XL', model: pair[2], note: pair[3] + ' element. The upper and lower elements are listed separately.', combination: 'all', position: pair[3].toLowerCase()});
      } else {
        separateModels(model).forEach(function (individual) {
          choices.push({brand: segment.brand, family: '', model: individual, note: note, combination: '', position: ''});
        });
      }
    });
    return choices.filter(function (choice, index) {
      return choices.findIndex(function (other) { return other.brand === choice.brand && other.family === choice.family && other.model === choice.model; }) === index;
    });
  }
  function housingKey(choice) {
    return [choice.brand, choice.family, choice.model].join(' ').toLowerCase().replace(/[^a-z0-9]/g, '');
  }
  // End of the title parser: scripts/build-housing-choices.mjs evaluates the code above this line.
  // One housing name listed for two different cartridges: said with the result (FIT-9), in the
  // words the search page uses.
  var SEVERAL_CARTRIDGES = 'This housing name is listed for more than one cartridge. Check the model, the size and the number on your current cartridge before you choose.';
  document.querySelectorAll('[data-ef-housing]').forEach(function (root) {
    if (root.dataset.initialized) return;
    var sources = Array.from(root.querySelectorAll('[data-ef-housing-entry]'));
    var brandSelect = root.querySelector('[data-ef-housing-brand]');
    var modelSelect = root.querySelector('[data-ef-housing-model]');
    var result = root.querySelector('[data-ef-housing-result]');
    var announcement = root.querySelector('[data-ef-housing-announcement]');
    var cartStatus = root.querySelector('[data-ef-housing-cart-status]');
    var copy = JSON.parse(root.querySelector('[data-ef-housing-copy]').textContent);
    var requirementsNode = root.querySelector('[data-ef-housing-requirements]');
    var requirements = requirementsNode ? JSON.parse(requirementsNode.textContent) : {};
    // snippets/ef-housing-choices.liquid (scripts/build-housing-choices.mjs, from excel.fit, excel.pages
    // and excel.content routes): `choices` the housings the titles do not name, `same` the names that are
    // one housing ("425" and "Crystal Water 425"), `pages` the page led by each brand for a cartridge.
    // The first build shipped the choices alone.
    var choicesNode = root.querySelector('[data-ef-housing-choices]');
    var fitData = {};
    try { fitData = choicesNode ? JSON.parse(choicesNode.textContent) : {}; } catch (error) { fitData = {}; }
    var fitChoices = fitData.choices || (fitData.same || fitData.pages ? {} : fitData);
    var sameHousing = fitData.same || {};
    var spellings = fitData.labels || {};
    var brandLandings = fitData.pages || {};
    var groupKeys = new Map();
    function groupKey(choice) {
      var own = housingKey(choice);
      return sameHousing[own] || own;
    }
    // Every name of the housing, the choice's own first: its cartridge count, its confirmation and its
    // brand page can be recorded under any of them.
    function keysOf(choice) {
      var own = housingKey(choice);
      return [own].concat((groupKeys.get(groupKey(choice)) || []).filter(function (key) { return key !== own; }));
    }
    function housingRequirement(choice) {
      var keys = keysOf(choice);
      for (var i = 0; i < keys.length; i += 1) if (requirements[keys[i]]) return requirements[keys[i]];
      return {mode: 'confirm'};
    }
    // A cartridge that fits several brands has one page per brand: the entry carries [housing key,
    // path, reference] rows (the product's excel.pages match). A row for any name of the housing, else
    // a row of the same brand whose model numbers the chosen name carries ("Crystal Water 425" for the
    // row "Waterway 425").
    function brandPage(data) {
      var rows;
      try { rows = JSON.parse(data.brandPages || '[]'); } catch (error) { rows = []; }
      rows = rows.filter(function (row) { return row.length === 3; });
      var keys = keysOf(data);
      var row = rows.filter(function (candidate) { return keys.indexOf(candidate[0]) !== -1; })[0];
      if (!row) {
        var brand = housingKey({brand: data.brand});
        var numbers = keys.join(' ').match(/\d+/g) || [];
        row = rows.filter(function (candidate) {
          var need = candidate[0].indexOf(brand) === 0 ? candidate[0].slice(brand.length).match(/\d+/g) || [] : [];
          return need.length && need.every(function (number) { return numbers.indexOf(number) !== -1; });
        })[0];
      }
      return row ? {url: row[1], reference: row[2]} : null;
    }
    // Owner, 2026-10-14: a click in a brand context opens a page led by that brand. The housing's
    // brand page, else the page led by its brand for this cartridge (full brand page or brand route).
    function landing(data) {
      var page = brandPage(data);
      if (page) return page;
      // [collection handle, reference]; a full path when the page sits under another product.
      var row = (brandLandings[data.handle] || {})[data.brand];
      if (!row) return null;
      return {url: row[0].charAt(0) === '/' ? row[0] : '/collections/' + row[0] + '/products/' + data.handle, reference: row[1] || ''};
    }
    // The housings the product page can confirm (excel.fit selection): only these carry the choice in the link.
    function confirmKey(data) {
      var fit = (data.fitKeys || '').split(',');
      return keysOf(data).filter(function (key) { return fit.indexOf(key) !== -1; })[0] || '';
    }
    function requiredHousingPack(choice) {
      return String(housingRequirement(choice).preferredPack || '');
    }
    function countStatement(choice) {
      var requirement = housingRequirement(choice);
      if (requirement.note) return requirement.note;
      if (requirement.mode === 'spa') return copy.housingCountVaries;
      if (requirement.mode === 'retrofit') return copy.housingCountRetrofit.replace('__COUNT__', requirement.count);
      if (requirement.mode === 'fixed' && requirement.count > 0) {
        return requirement.count === 1 ? copy.singleHousing : copy.housingCount.replace('__COUNT__', requirement.count);
      }
      return copy.housingCountConfirm;
    }
    // The count belongs to the housing, the pack to the product. Where they differ, say how
    // one relates to the other, so "takes 1 cartridge" above a 15-pack is not left to guess.
    function packStatement(choice) {
      var requirement = housingRequirement(choice);
      var pack = parseInt(choice.pack, 10);
      var count = requirement.count;
      if (requirement.note || requirement.mode !== 'fixed' || !(count > 0) || !(pack > 0) || choice.isKit === 'true' || choice.combination === 'all' || pack === count) return '';
      if (pack < count) {
        var orders = Math.ceil(count / pack);
        return 'Order ' + orders + (pack === 1 ? '' : ' of this ' + pack + '-pack') + ' for a full set.';
      }
      var sets = Math.floor(pack / count);
      var spare = pack - sets * count;
      if (count === 1) return 'This ' + pack + '-pack is ' + pack + ' replacements.';
      return 'This ' + pack + '-pack is ' + sets + ' full set' + (sets === 1 ? '' : 's') + (spare ? ' with ' + spare + ' to spare.' : '.');
    }
    var cartItems = [];
    var cartBusy = false;
    var cartVersion = 0;
    var cartRead = null;
    var cartControls = [];
    var fixedBrand = root.dataset.fixedBrand;
    // Housings the approved compatibility data lists that the title does not name (fitChoices above).
    var entries = [];
    sources.forEach(function (source) {
      var extra = (fitChoices[source.dataset.handle] || []).map(function (row) {
        return {brand: row[0], family: '', model: row[1], note: '', combination: '', position: ''};
      });
      titleChoices(source.dataset.title || '').concat(extra).forEach(function (choice) {
        if (fixedBrand && choice.brand !== fixedBrand) return;
        var entry = source.cloneNode(true);
        Object.keys(choice).forEach(function (key) { entry.dataset[key] = choice[key]; });
        entries.push(entry);
      });
    });
    // One option per housing however it is spaced or written ("PRC 75" and "PRC75" list both
    // cartridges; "425" and "Crystal Water 425" are one housing). The option keeps the spelling the
    // build chose; a cartridge listed under two of its names shows once.
    var groups = new Map();
    var groupLabels = new Map();
    entries.forEach(function (entry) {
      var own = housingKey(entry.dataset);
      var key = groupKey(entry.dataset);
      if (!groups.has(key)) { groups.set(key, []); groupKeys.set(key, []); }
      if (groupKeys.get(key).indexOf(own) === -1) groupKeys.get(key).push(own);
      if (own === key && !groupLabels.has(key)) groupLabels.set(key, entry);
      if (!groups.get(key).some(function (other) { return other.dataset.variantId === entry.dataset.variantId; })) groups.get(key).push(entry);
    });
    // brand, family and model as the option shows them.
    function labelOf(key) {
      var d = (groupLabels.get(key) || groups.get(key)[0]).dataset;
      return {brand: d.brand, family: d.family, model: spellings[key] || d.model};
    }
    function clearResult() {
      announcement.textContent = '';
      cartControls = [];
      cartStatus.hidden = true;
      cartStatus.replaceChildren();
      result.classList.remove('ef-housing__result--multiple');
      result.dataset.state = 'empty';
      result.replaceChildren(paragraph('Choose ' + (fixedBrand ? 'a housing model' : 'a brand and housing model') + ' to see its matching replacement.', 'ef-housing__prompt'));
      result.hidden = false;
    }
    function option(text, value) { return new Option(text, value); }
    function populate() {
      clearResult();
      var brand = fixedBrand || brandSelect.value;
      modelSelect.replaceChildren(option(brand ? 'Select your housing' : 'Choose a brand first', ''));
      modelSelect.disabled = !brand;
      var families = new Map();
      var label = function (pair) { var d = labelOf(pair[0]); return [d.family, d.model].join(' '); };
      Array.from(groups.entries()).filter(function (pair) { return pair[1][0].dataset.brand === brand; })
        .sort(function (a, b) { return label(a).localeCompare(label(b), undefined, {numeric: true, sensitivity: 'base'}); })
        .forEach(function (pair) {
          var shown = labelOf(pair[0]);
          var family = shown.family;
          if (family && !families.has(family)) {
            var optgroup = document.createElement('optgroup');
            optgroup.label = family; families.set(family, optgroup); modelSelect.append(optgroup);
          }
          (family ? families.get(family) : modelSelect).append(option((family ? family + ' — ' : '') + shown.model, pair[0]));
        });
      if (brand) modelSelect.append(option('My housing is not listed / I am not sure', '__unknown'));
    }
    function paragraph(text, className) {
      var p = document.createElement('p'); p.textContent = text;
      if (className) p.className = className;
      return p;
    }
    function cartMessage(message) {
      cartStatus.replaceChildren(document.createTextNode(message + ' '));
      var link = document.createElement('a'); link.href = root.dataset.cartUrl; link.textContent = copy.viewCart;
      cartStatus.append(link); cartStatus.hidden = false;
      cartStatus.classList.add('ef-housing__cart-status--error');
    }
    function matchingCartItems(id) {
      return cartItems.filter(function (item) {
        return String(item.variant_id || item.id) === id && !item.selling_plan_allocation && !item.parent_relationship;
      });
    }
    function cartQuantity(id) {
      return matchingCartItems(id).reduce(function (quantity, item) { return quantity + item.quantity; }, 0);
    }
    function updateCartControls() {
      cartControls.forEach(function (control) {
        var quantity = cartQuantity(control.entry.dataset.variantId);
        var available = control.entry.dataset.available === 'true' && /^\d+$/.test(control.entry.dataset.variantId);
        control.add.hidden = quantity > 0;
        control.stepper.hidden = quantity === 0;
        control.add.disabled = cartBusy || !available;
        control.minus.disabled = cartBusy;
        control.plus.disabled = cartBusy || !available;
        control.value.textContent = quantity;
        control.value.setAttribute('aria-label', copy.quantity.replace('__COUNT__', quantity));
        control.group.setAttribute('aria-busy', String(cartBusy));
      });
    }
    function acceptCart(cart) {
      if (!Array.isArray(cart.items)) throw new Error(copy.cartError);
      cartItems = cart.items;
      var count = cart.item_count;
      document.querySelectorAll('.cart-icon-indicator, .site-header__cart-indicator, [data-cart-count]').forEach(function (el) {
        el.classList.toggle('hide', count === 0);
        if (el.hasAttribute('data-cart-count')) el.textContent = count;
      });
      updateCartControls();
    }
    async function cartRequest(url, payload) {
      var options = {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}};
      if (payload) {
        options.method = 'POST';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(payload);
      }
      var response = await fetch(url, options);
      var data = await response.json();
      if (!response.ok) { var error = new Error(data.description || copy.cartError); error.confirmed = true; throw error; }
      return data;
    }
    function refreshCart() {
      if (cartBusy || typeof window.fetch !== 'function') return Promise.resolve();
      if (cartRead) return cartRead;
      var version = cartVersion;
      cartRead = cartRequest(root.dataset.cartUrl + '.js').then(function (cart) {
        if (version === cartVersion && !cartBusy) acceptCart(cart);
      }).catch(function () {}).finally(function () { cartRead = null; });
      return cartRead;
    }
    async function changeCart(control, direction, button) {
      var id = control.entry.dataset.variantId;
      if (cartBusy || !/^\d+$/.test(id) || (direction > 0 && control.entry.dataset.available !== 'true')) return;
      cartBusy = true;
      cartVersion += 1;
      cartStatus.hidden = true;
      cartStatus.replaceChildren();
      updateCartControls();
      var added = false;
      try {
        acceptCart(await cartRequest(root.dataset.cartUrl + '.js'));
        if (direction > 0) {
          await cartRequest(root.dataset.cartAddUrl, {items: [{id: id, quantity: 1}]});
          acceptCart(await cartRequest(root.dataset.cartUrl + '.js'));
          added = true;
        } else {
          var item = matchingCartItems(id).find(function (line) { return line.quantity > 0; });
          if (item) acceptCart(await cartRequest(root.dataset.cartChangeUrl, {id: item.key, quantity: item.quantity - 1}));
        }
      } catch (error) {
        try { acceptCart(await cartRequest(root.dataset.cartUrl + '.js')); } catch (readError) {}
        cartMessage(error.confirmed ? error.message : copy.cartUnconfirmed);
      } finally {
        cartBusy = false;
        updateCartControls();
        if (button.isConnected && (document.activeElement === button || document.activeElement === document.body)) {
          (cartQuantity(id) ? (direction > 0 ? control.plus : control.minus) : control.add).focus();
        }
      }
      if (added && window.theme && window.theme.Notify && typeof window.theme.Notify.open === 'function') window.theme.Notify.open('success', false, true);
    }
    function purchaseControl(entry, pack) {
      var group = document.createElement('div'); group.className = 'ef-housing__cart-control';
      var product = 'Excel Filters ' + entry.dataset.sku + ', ' + pack;
      var add = document.createElement('button'); add.type = 'button'; add.className = 'ef-housing__add'; add.textContent = copy.addToCart;
      add.setAttribute('aria-label', copy.addToCart + ' — ' + product);
      var stepper = document.createElement('div'); stepper.className = 'ef-housing__quantity'; stepper.hidden = true;
      stepper.setAttribute('role', 'group'); stepper.setAttribute('aria-label', copy.inCart + ' — ' + product);
      var minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', copy.decrease + ' — ' + product);
      var value = document.createElement('span'); value.className = 'ef-housing__quantity-value'; value.setAttribute('role', 'status'); value.setAttribute('aria-live', 'polite'); value.setAttribute('aria-atomic', 'true');
      var plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', copy.increase + ' — ' + product);
      stepper.append(minus, value, plus); group.append(add, stepper);
      var control = {entry: entry, group: group, add: add, stepper: stepper, minus: minus, value: value, plus: plus};
      add.addEventListener('click', function () { changeCart(control, 1, add); });
      plus.addEventListener('click', function () { changeCart(control, 1, plus); });
      minus.addEventListener('click', function () { changeCart(control, -1, minus); });
      cartControls.push(control);
      return group;
    }
    function showMatch() {
      clearResult();
      if (!modelSelect.value) return;
      result.replaceChildren();
      result.dataset.state = 'match';
      result.hidden = false;
      if (modelSelect.value === '__unknown') {
        result.dataset.state = 'unknown';
        announcement.textContent = 'Find it by cartridge number';
        result.append(paragraph('Find it by cartridge number', 'ef-housing__fallback-title'));
        result.append(paragraph('Match the number on your current cartridge, or compare its dimensions and end caps.', 'ef-housing__fallback-copy'));
        var help = document.createElement('div'); help.className = 'ef-housing__help-links';
        [['Cartridge-number chart', '/pages/pool-filter-cartridge-cross-reference'], ['How to measure', '/pages/how-to-measure-your-pool-or-spa-filter-cartridge']].forEach(function (item) {
          var link = document.createElement('a'); link.textContent = item[0]; link.href = item[1]; help.append(link);
        });
        result.append(help);
        return;
      }
      var matches = groups.get(modelSelect.value) || [];
      if (!matches.length) return;
      var requiredPack = requiredHousingPack(matches[0].dataset);
      if (requiredPack) {
        matches = matches.filter(function (entry) { return entry.dataset.pack === requiredPack; });
        if (!matches.length) {
          result.dataset.state = 'incomplete';
          result.append(paragraph('This housing uses ' + requiredPack + (requiredPack === '1' ? ' cartridge. ' : ' cartridges. ') + 'The ' + requiredPack + '-pack is not in this collection.'));
          announcement.textContent = result.textContent;
          return;
        }
      }
      var combined = matches.some(function (entry) { return entry.dataset.combination === 'all'; });
      if (combined && !(matches.some(function (e) { return e.dataset.position === 'upper'; }) && matches.some(function (e) { return e.dataset.position === 'lower'; }))) {
        result.dataset.state = 'incomplete';
        result.append(paragraph('This housing needs two different cartridges. The complete pair is not in this collection.'));
        announcement.textContent = result.textContent;
        var waterco = document.createElement('a'); waterco.href = '/collections/replacement-filter-cartridges-waterco'; waterco.textContent = 'View the Waterco collection'; result.append(waterco); return;
      }
      var multiple = matches.length > 1;
      result.classList.toggle('ef-housing__result--multiple', multiple);
      var first = labelOf(modelSelect.value);
      var context = 'For ' + [first.brand, first.family, first.model].filter(Boolean).join(' ');
      // Two packs of one cartridge are one cartridge (XLS-731 1-pack and 4-pack); the Opal XL270
      // pair has its own note.
      var cartridges = matches.reduce(function (list, entry) { if (list.indexOf(entry.dataset.sku) === -1) list.push(entry.dataset.sku); return list; }, []);
      var several = !combined && cartridges.length > 1;
      announcement.textContent = context + ': ' + matches.map(function (entry) { return 'Excel Filters ' + entry.dataset.sku; }).join(', ') + (several ? '. ' + SEVERAL_CARTRIDGES : '');
      if (combined) result.append(paragraph(copy.pair, 'ef-housing__pair-note'));
      if (several) result.append(paragraph(SEVERAL_CARTRIDGES, 'ef-housing__pair-note ef-housing__several-note'));
      var cards = document.createElement('div'); cards.className = 'ef-housing__matches';
      matches.forEach(function (entry) {
        var data = entry.dataset;
        var page = landing(data);
        var reference = page && page.reference ? page.reference : data.reference;
        var card = document.createElement('article'); card.className = 'ef-housing__match';
        var header = document.createElement('div'); header.className = 'ef-housing__fit-line';
        var fit = paragraph('', 'ef-housing__context');
        var check = document.createElement('span'); check.textContent = '✓'; check.setAttribute('aria-hidden', 'true'); fit.append(check, document.createTextNode(' ' + context));
        header.append(fit);
        var countLine = countStatement(data);
        var packLine = packStatement(data);
        if (packLine) countLine = countLine.replace(/[.\s]+$/, '') + '. ' + packLine;
        header.append(paragraph(countLine, 'ef-housing__required'));
        card.append(header);
        var body = document.createElement('div'); body.className = 'ef-housing__body';
        if (entry.dataset.image) {
          var img = document.createElement('img'); img.src = data.image; img.alt = 'Excel Filters ' + data.sku; img.width = 144; img.height = 176; img.loading = 'lazy'; body.append(img);
        } else body.classList.add('ef-housing__body--no-image');
        var info = document.createElement('div'); info.className = 'ef-housing__info';
        var name = document.createElement('h3'); name.className = 'ef-housing__product-name'; name.textContent = 'Excel Filters ' + entry.dataset.sku; info.append(name);
        var pack = data.isKit === 'true' ? copy.kit : copy.pack.replace('__COUNT__', data.pack);
        var subtitle = paragraph('', 'ef-housing__subtitle');
        var packLabel = document.createElement('span'); packLabel.className = 'ef-housing__pack'; packLabel.textContent = pack; subtitle.append(packLabel);
        if (reference) {
          subtitle.append(document.createTextNode(' | '));
          var referenceLabel = document.createElement('span'); referenceLabel.className = 'ef-housing__reference';
          referenceLabel.textContent = copy.replaces.replace('__REFERENCE__', reference); subtitle.append(referenceLabel);
        }
        info.append(subtitle);
        if (data.isKit !== 'true' || [data.diameter, data.length, data.top, data.bottom].some(Boolean)) {
          var specs = document.createElement('dl'); specs.className = 'ef-housing__specs';
          ['diameter', 'length', 'top', 'bottom'].forEach(function (key) {
            var spec = document.createElement('div');
            var label = document.createElement('dt'); label.textContent = copy[key];
            var value = document.createElement('dd'); value.textContent = data[key] || copy.missing;
            spec.append(label, value); specs.append(spec);
          });
          info.append(specs);
        }
        body.append(info); card.append(body);
        if (data.note) card.append(paragraph(data.note, 'ef-housing__fit-note'));
        var purchase = document.createElement('div'); purchase.className = 'ef-housing__purchase';
        var pricing = document.createElement('div'); pricing.className = 'ef-housing__pricing';
        if (data.price) pricing.append(paragraph(data.price, 'ef-housing__price'));
        pricing.append(paragraph(data.available === 'true' ? copy.shipping : copy.unavailable, 'ef-housing__shipping'));
        purchase.append(pricing);
        var actions = document.createElement('div'); actions.className = 'ef-housing__actions';
        actions.append(purchaseControl(entry, pack));
        // The chosen housing travels with the link when the page can confirm it. Where the link goes:
        // the page led by the chosen brand, else this collection's brand route, else the product page.
        var link = document.createElement('a'); link.className = 'ef-housing__cta';
        var confirmed = confirmKey(data);
        link.href = (page ? page.url : data.routeUrl || entry.querySelector('a').getAttribute('href')) + (confirmed ? '?housing=' + encodeURIComponent(confirmed) : '');
        var linkLabel = document.createElement('span'); linkLabel.className = 'ef-housing__cta-label'; linkLabel.textContent = copy.details;
        var linkIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        linkIcon.setAttribute('class', 'ef-housing__cta-icon'); linkIcon.setAttribute('viewBox', '0 0 24 24');
        linkIcon.setAttribute('aria-hidden', 'true'); linkIcon.setAttribute('focusable', 'false');
        linkIcon.setAttribute('fill', 'none'); linkIcon.setAttribute('stroke', 'currentColor'); linkIcon.setAttribute('stroke-width', '1.7');
        linkIcon.setAttribute('stroke-linecap', 'round'); linkIcon.setAttribute('stroke-linejoin', 'round');
        var linkArrow = document.createElementNS('http://www.w3.org/2000/svg', 'path'); linkArrow.setAttribute('d', 'M4 12h15M13 6l6 6-6 6');
        linkIcon.append(linkArrow); link.append(linkLabel, linkIcon);
        link.setAttribute('aria-label', copy.details + ' — Excel Filters ' + data.sku + ', ' + pack);
        actions.append(link); purchase.append(actions); card.append(purchase); cards.append(card);
      });
      result.append(cards);
      updateCartControls();
      refreshCart();
    }
    function rememberSelection() {
      try {
        var state = window.history.state;
        if (state !== null && (typeof state !== 'object' || Array.isArray(state))) return;
        window.history.replaceState(Object.assign({}, state, {efHousingSelection: {
          path: window.location.pathname,
          brand: fixedBrand || brandSelect.value,
          model: modelSelect.value
        }}), '');
      } catch (_) { /* Selection still works when history writes are unavailable. */ }
    }
    function restoreSelection() {
      var saved;
      try { saved = window.history.state && window.history.state.efHousingSelection; } catch (_) {}
      if (!saved || saved.path !== window.location.pathname) saved = null;
      var model = saved ? saved.model : modelSelect.value;
      if (brandSelect && saved) brandSelect.value = saved.brand;
      populate();
      if (model) {
        modelSelect.value = model;
        if (modelSelect.value) showMatch();
      }
      refreshCart();
    }
    if (brandSelect) {
      Array.from(new Set(entries.map(function (entry) { return entry.dataset.brand; }))).sort()
        .forEach(function (brand) { brandSelect.append(option(brand, brand)); });
      brandSelect.addEventListener('change', function () { populate(); rememberSelection(); });
    }
    modelSelect.addEventListener('change', function () { showMatch(); rememberSelection(); });
    root.dataset.initialized = 'true';
    root.querySelector('[data-ef-housing-controls]').hidden = false;
    restoreSelection();
    window.addEventListener('focus', refreshCart);
    // Browsers restore form values after initial scripts and around pageshow.
    // Rebuild dependent options after that restoration, including Back/Forward.
    window.addEventListener('pageshow', function () { window.setTimeout(restoreSelection, 0); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCart(); });
    document.addEventListener('cart:updated', refreshCart);
    var notification = document.getElementById('NotificationSuccess');
    if (notification) new MutationObserver(function () {
      if (notification.getAttribute('aria-hidden') === 'false') refreshCart();
    }).observe(notification, {attributes: true, attributeFilter: ['aria-hidden']});
  });
})();
